const units = ['', 'K', 'M', 'G', 'T', 'P'];

/**
 * Given a byte value and optional precision, returns a formatted memory string.
 * (Example: 12.345 KB)
 */
export function formatMemoryString(input: number, precision: number = 3): string {
  // Math.log(0) is -Infinity. Also bail if it's somehow NaN or infinite.
  if (!input || !Number.isFinite(input)) {
    return 'unknown';
  }

  // Heap deltas can be negative, and they might end up in the "top 10" tasks
  // if there weren't many tasks (this previously caused "NaN undefined" logs)
  const sign = input < 0 ? '-' : '';
  input = Math.abs(input);

  const index = Math.min(units.length - 1, Math.floor(Math.log(input) / Math.log(1024)));

  const result = input / Math.pow(1024, index);

  return `${sign}${precision === 0 ? Math.round(result).toString() : result.toFixed(precision)} ${units[index]}B`;
}
